/* Minimal progressive enhancement. Nothing here is required for navigation:
   variant links, filters and search all work without JavaScript. */
(function () {
  'use strict';
  var menu = document.getElementById('btnMenu');
  var close = document.getElementById('btnMenuClose');
  var drawer = document.getElementById('MobileNav');
  var scrim = document.getElementById('Scrim');
  function open() {
    if (!drawer) return;
    drawer.classList.add('is-on'); drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-on');
    if (menu) menu.setAttribute('aria-expanded', 'true');
  }
  function shut() {
    if (!drawer) return;
    drawer.classList.remove('is-on'); drawer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('is-on');
    if (menu) menu.setAttribute('aria-expanded', 'false');
  }
  if (menu) menu.addEventListener('click', open);
  if (close) close.addEventListener('click', shut);
  if (scrim) scrim.addEventListener('click', shut);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });

  var main = document.getElementById('GalMain');
  var thumbs = document.querySelectorAll('.gal__thumb');
  Array.prototype.forEach.call(thumbs, function (t, i) {
    if (i === 0) t.classList.add('is-on');
    t.addEventListener('click', function () {
      if (!main) return;
      main.src = t.getAttribute('data-full');
      Array.prototype.forEach.call(thumbs, function (x) { x.classList.remove('is-on'); });
      t.classList.add('is-on');
    });
  });
})();
